module.exports = __webpack_public_path__ + "img/lg_ring_y_o_null_0@3x.06ff99c6.png";